var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 20,
    viewBox: "0 0 15 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 19C9.66667 16.7347 14 11.102 14 6.69388C14 2.28571 9.73447 1 7.5 1C5.26552 1 0.999949 2.12931 1 6.69388C1.00005 11.4694 5.19792 16.7959 7.5 19ZM7.5 10C9.55134 10 11.2143 8.53475 11.2143 6.72727C11.2143 4.9198 9.55134 3.45455 7.5 3.45455C5.44866 3.45455 3.78571 4.9198 3.78571 6.72727C3.78571 8.53475 5.44866 10 7.5 10Z",
    fill: "#23222F",
    stroke: "#23222F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeo);
export default __webpack_public_path__ + "static/media/geo.0c89d1627e93f363eeae037547cf3f08.svg";
export { ForwardRef as ReactComponent };